module.exports = __webpack_public_path__ + "img/03-3.32a32ceb.png";